module.exports = __webpack_public_path__ + "static/media/Placaj ceramic Klinker Bastille.19f41cd7.jpg";